import React from 'react';
import { NavLink } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import './linklist.styl'

class LinkList extends React.Component {
  render(){
    return (
      <ul className="link-list">
        { this.props.links.map(link => {
            return (
              <li key={ link.text }>
                { link.linkAddress &&
                  <NavLink to={ link.linkAddress }>{ link.text }</NavLink>
                }
                { link.externalLinkAddress &&
                  <a href={link.externalLinkAddress} target={ (link.target ? link.target : '_parent') }>{ link.text }</a>
                }
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default LinkList;



// WEBPACK FOOTER //
// ./src/components/linklist/LinkList.js